const WORKSPACES_KEY_BASE = 'workspaces';
const POLL = 'poll';
export const WorkspacesKeyFactory = {
    all: () => [WORKSPACES_KEY_BASE],
    byWorkspace: (workspaceId) => [
        ...WorkspacesKeyFactory.all(),
        workspaceId,
    ],
    byWorkspacePoll: (workspaceId) => [
        ...WorkspacesKeyFactory.all(),
        POLL,
        workspaceId,
    ],
};
